import { useLocation, useNavigate } from "react-router-dom";

import AppOptions from "../../../components/GrowthCloudStore/Tabs/AppDetail/AppOptions";
import AppCard from "../../../components/GrowthCloudStore/Cards/AppCard";
import useGrowthCloudStore from "../../../hooks/useGrowthCloudStore";
import AppEmptyState from "../../../elements/AppEmptyState";
import AppSpinner from "../../../elements/AppSpinner";

const ManageCloudAppsView = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const { installedOnWorkspace, loading } = useGrowthCloudStore({
    disabled: false,
  });

  return (
    <>
      {installedOnWorkspace?.length ? (
        installedOnWorkspace?.map((app) => {
          return (
            <AppCard
              key={app.id}
              app={app}
              onClick={(e) => {
                e.stopPropagation();
                navigate(
                  `${pathname}?store=true&page=installed-apps&app=${app.id}`
                );
              }}
              options={<AppOptions app={app} viewInMarketplace={true} />}
              workspaceVisibility={true}
            />
          );
        })
      ) : loading ? (
        <AppSpinner />
      ) : (
        <AppEmptyState
          title="No Apps Installed"
          description="You have no apps installed on this workspace."
          className="w-100"
        />
      )}
    </>
  );
};

export default ManageCloudAppsView;
